module.exports = __webpack_public_path__ + "static/skyline-6057cda0041d469bbd8bd6ef1a518ce0.svg";